export default "__VITE_ASSET__f5c7f62c__"